// extracted by css-extract-rspack-plugin
export default {"root":"root-RLRBH8","statusChip":"statusChip-KhaZ32","logoRow":"logoRow-QXK9FG","chewyIcon":"chewyIcon-eZ4Sgd"};